<template>
    <div class="container-fluid">
        <record-list :records="getRecords"></record-list>
    </div>
</template>

<script>
import RecordList from '@/components/RecordList';
import {mapGetters, mapActions} from 'vuex';
export default {
    name: "FormatRecords",
    components: {RecordList},
    created(){
        this.fetchFormatRecords(this.$route.params.id);
    },
    methods: {
        ...mapActions(['fetchFormatRecords'])
    },
    computed: mapGetters(['getRecords']),
}
</script>

<style>

</style>